/**
 * Validates Soulmask client cluster ``cluster_master_address`` (``clientserverconnect``), ``host:port`` form.
 * Returns an i18n key when invalid, or ``null`` when valid.
 */
export function getClusterClientMasterAddressIssueKey(addrRaw: string): string | null {
  const addr = addrRaw.trim();
  if (!addr) {
    return "ngp/settings/section/cluster/client_master_address_required";
  }
  const lastColon = addr.lastIndexOf(":");
  if (lastColon <= 0) {
    return "ngp/settings/section/cluster/client_master_address_invalid";
  }
  const portStr = addr.slice(lastColon + 1).trim();
  const host = addr.slice(0, lastColon).trim();
  if (!host) {
    return "ngp/settings/section/cluster/client_master_address_invalid";
  }
  if (!/^\d+$/.test(portStr)) {
    return "ngp/settings/section/cluster/client_master_address_invalid";
  }
  const port = Number(portStr);
  if (!Number.isInteger(port) || port < 1 || port > 65535) {
    return "ngp/settings/section/cluster/client_master_address_invalid";
  }
  return null;
}

export function getSoulmaskClusterCommitBlockedMessageKey(virtual: Record<string, unknown> | undefined): string | null {
  if (!virtual) return null;
  const enabled = virtual.cluster_enabled === true || virtual.cluster_enabled === "true";
  if (!enabled) return null;
  if (virtual.cluster_role !== "client") return null;
  const addr = String(virtual.cluster_master_address ?? "");
  return getClusterClientMasterAddressIssueKey(addr);
}
